import config from './config';

const template = document.getElementById('template_suggestion');

export async function getSuggestions(text) {
  if ('content' in document.createElement('template')) {
    const suggestions = await fetchSuggestions(text);

    return suggestions.map(s => {
      const element = template.content.cloneNode(true);
      const addressEl = element.querySelector('.address');

      const address = `${s.street}, ${s.district}`;

      addressEl.textContent = address;

      return {
        ...s,
        address,
        element
      };
    });
  } else {
    alert('Templating not supported!');
  }
}

export async function fetchSuggestions(text: string) {
  const url = new URL(`${config.hosts.api}/address`);
  url.searchParams.set('search', text);

  const response = await fetch(url);
  return await response.json();
}
